import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CreateChancel, CustomNumericFormat, Loader } from 'components';
import { systemActions } from 'store';
import { FindLoad } from 'utils';

const GET_ACTION = 'GET_SUPERVISION_CONFIG';
const UPDATE_ACTION = 'UPDATE_SUPERVISION_CONFIG';

export const SupervisionSettings = () => {
    const dispatch = useDispatch();
    const config = useSelector((state) => state.system.supervisionConfig);
    const loading = FindLoad(GET_ACTION);
    const updating = FindLoad(UPDATE_ACTION);
    const [form, setForm] = useState(null);
    const [hasChanges, setHasChanges] = useState(false);

    useEffect(() => {
        dispatch(systemActions.getSupervisionConfig());
    }, []);

    useEffect(() => {
        if (config) {
            setForm({ rbt: config });
            setHasChanges(false);
        }
    }, [config]);

    const updateRbt = (key, value) => {
        setForm((prev) => ({
            ...prev,
            rbt: { ...prev.rbt, [key]: value },
        }));
        setHasChanges(true);
    };

    const handleSave = () => {
        dispatch(systemActions.updateSupervisionConfig({ rbt: form.rbt }));
        setHasChanges(false);
    };

    const handleReset = () => {
        setForm({ rbt: config });
        setHasChanges(false);
    };

    if (loading?.length) {
        return <Loader height={350} />;
    }

    return (
        <div className="supervision-settings-wrapper">
            <div className="supervision-section">

              <div className='supervision-section-header-box'>
                <p className="settings-subsection-title">RBT Ongoing Supervision</p>
                <p className="settings-subsection-desc">
                    BACB requirements for Registered Behavior Technician supervision.
                </p>
              </div>

                <div className="settings-field-row">
                    <span className="settings-field-label">Minimum Supervision %</span>
                    <CustomNumericFormat
                        className="settings-numeric-input"
                        name="minPercent"
                        value={form?.rbt?.minPercent}
                        handleChangeMiles={(e, sourceInfo) => {
                            if (sourceInfo?.source === 'event') updateRbt('minPercent', e.floatValue);
                        }}
                        suffix=" %"
                        decimalScale={1}
                        noError={true}
                    />
                </div>
                <p className="settings-field-hint">
                    % of monthly service hours that must be supervised (BACB standard: 5%)
                </p>

                <div className="settings-field-row">
                    <span className="settings-field-label">Minimum Contacts per Month</span>
                    <CustomNumericFormat
                        className="settings-numeric-input"
                        name="minContactsPerMonth"
                        value={form?.rbt?.minContactsPerMonth}
                        handleChangeMiles={(e, sourceInfo) => {
                            if (sourceInfo?.source === 'event') updateRbt('minContactsPerMonth', e.floatValue);
                        }}
                        decimalScale={0}
                        noError={true}
                    />
                </div>
                <p className="settings-field-hint">
                    Min # of supervision sessions required per month (BACB standard: 2)
                </p>

                {/*<div className="supervision-toggles-box-wrapper">*/}
                {/*    <div className="supervision-toggle-wrapper">*/}
                {/*        <div style={{ marginTop: 2 }}>*/}
                {/*            <CustomizedSwitch*/}
                {/*                checked={!!form?.rbt?.enableTracking}*/}
                {/*                handleClick={() => handleToggle('enableTracking')}*/}
                {/*            />*/}
                {/*        </div>*/}
                {/*        <div className="supervision-toggle-text">*/}
                {/*            <p className="supervision-toggle-label">Enable supervision tracking</p>*/}
                {/*            <p className="supervision-toggle-desc">*/}
                {/*                Automatically track supervision hours and calculate compliance percentages for RBTs.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*    <div className="supervision-toggle-wrapper">*/}
                {/*        <div style={{ marginTop: 2 }}>*/}
                {/*            <CustomizedSwitch*/}
                {/*                checked={!!form?.rbt?.enableAlerts}*/}
                {/*                handleClick={() => handleToggle('enableAlerts')}*/}
                {/*            />*/}
                {/*        </div>*/}
                {/*        <div className="supervision-toggle-text">*/}
                {/*            <p className="supervision-toggle-label">Supervision alerts & reminders</p>*/}
                {/*            <p className="supervision-toggle-desc">*/}
                {/*                Notify supervisors and staff when they are at risk of non-compliance near the end of the*/}
                {/*                month.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}


            </div>

            {hasChanges &&
                <div style={{marginTop: 12}}>
                <CreateChancel
                    type={'button'}
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    disabled={!hasChanges}
                    loader={updating?.length}
                    create={'Save Changes'}
                    chancel={'Cancel'}
                    onCreate={handleSave}
                    onClose={handleReset}
                    buttonWidth="150px"
                />
                </div>
            }
        </div>
    );
};
